import {
  ConsultantIcon,
  ContractorIcon,
  DeveloperIcon,
  LenderIcon,
  OwnerIcon,
} from "assets/icons";
import { To } from "react-router-dom";

export interface LinkProps {
  id: number;
  name: string;
  path: To;
  showIcon?: boolean;
}

export interface SolutionProps {
  name: string;
  path: string;
  icon?: string;
  description?: string;
}

export const links: LinkProps[] = [
  {
    id: 1,
    name: "Solutions",
    path: "#",
    showIcon: true,
  },
  {
    id: 2,
    name: "Pricing",
    path: "#",
    showIcon: true,
  },
  {
    id: 3,
    name: "About us",
    path: "about-us",
  },
];

export const solutionsData: SolutionProps[] = [
  {
    name: "For Lenders",
    path: "lender",
    icon: LenderIcon,
    description: "Control Projects You Finance",
  },
  {
    name: "For Contractors",
    path: "contractor",
    icon: ContractorIcon,
    description: "Endless projects, instant access",
  },
  {
    name: "For Project Developers",
    path: "developer",
    icon: DeveloperIcon,
    description: "Project Funding Made Simple",
  },
  {
    name: "For Consultants",
    path: "consultant",
    icon: ConsultantIcon,
    description: "Unlimited projects, quick bids",
  },
  {
    name: "For Project Owners",
    path: "owner",
    icon: OwnerIcon,
    description: "Smart, Efficient Project Procurement",
  },
];

export const pricingData: SolutionProps[] = [
  {
    name: "Enterprise Plans",
    path: "pricing/enterprise",
  },
  {
    name: "Premium Plans",
    path: "pricing/premium",
  },
];
